import './style.scss';

import React, { useState, useEffect, useContext } from 'react';

import { Avatar, Button } from '../../atoms';
import { CreateEvaluationKnowledgeContext } from '../../../pctContexts/contextEvaluationKnowledge';
import { useHistory } from 'react-router-dom';

import { initEvaluation } from '../../../services/api';

type Props = {};

const EvaluationKnowledgeCardFeedback = ({}: Props) => {
    const {
        modalLoading,
        contextCurrentEvaluation,
        contextCurrentAvaliationResult,
        contextCurrentIdUser,
        contextCurrentIdEnrollment,
        contextCurrentIdEvaluation,
        contextCurrentNodeEnrollment,
    } = useContext(CreateEvaluationKnowledgeContext);

    const [statusFeed, setStatusFeed] = useState(true);
    const history = useHistory();

    const pretest = contextCurrentEvaluation.questionnaireType === 'PRE_TEST';

    const [valueAttempt, setValueAttempt] = useState(contextCurrentEvaluation.maxTries - contextCurrentAvaliationResult.attempts);

    const [valueFeed] = useState(contextCurrentAvaliationResult.grade);
    const [valueMedia] = useState(contextCurrentAvaliationResult.masteryScore);

    const [updatedSpeed, setuUdatedSpeed] = useState(-45);

    useEffect(() => {
        let upSpeed = Math.round((valueFeed * 180) / 100) - 45;

        if (valueFeed >= valueMedia) {
            setStatusFeed(true);
            if (contextCurrentEvaluation.parameters.lockAfterApproval === '1') {
                setValueAttempt(0);
            }
        } else {
            setStatusFeed(false);
        }

        setTimeout(() => {
            setuUdatedSpeed(upSpeed);
        }, 1000 * 0.5);
    }, [valueFeed]);

    const restartEvaluation = () => {
        modalLoading.show({
            obj: {
                content: () => {
                    return (
                        <div className="alertText">
                            <p>Aguarde, sua avaliação está sendo reiniciada.</p>
                        </div>
                    );
                },
                closeBtn: false,
                loadding: true,
                className: 'evaluationsModal',
            },
        });

        const objInit = {
            idEnrollment: contextCurrentIdEnrollment,
            idNodeEnrollment: contextCurrentNodeEnrollment,
            idEvaluation: contextCurrentIdEvaluation,
            idUser: contextCurrentIdUser,
            questionnaireType: contextCurrentAvaliationResult.questionnaireType,
        };

        initEvaluation(objInit)
            .then((response) => {
                modalLoading.remove();
                history.push(`/evaluations/${objInit.idEnrollment}/${objInit.idEvaluation}/${response.data.idQuestionnaire}`);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const statusFeedStatus = () => {
        let statusFeedTxt = statusFeed ? 'statusFeedPassed' : 'statusFeedfaield';
        // statusFeedTxt = pretest ? 'statusFeedPreTest' : statusFeedTxt;

        return statusFeedTxt;
    };

    return (
        <div className={`cardFeedbackEvaluationKnowledge ${statusFeedStatus()}`}>
            <div className={`blockCF blockCF01`}>
                <Avatar className="avatarHrader" />

                <div className="speedContainer">
                    <div className="speedbox">
                        <div className="speedbox__score" style={{ transform: 'rotate(' + updatedSpeed + 'deg)' }} />
                        <div className="speedbox__groove" />
                    </div>

                    <div className="pointContainer">
                        <div className="pCTitle">Nota</div>
                        <div className="pcPoint">{valueFeed}</div>
                        <div className="pCPorc">de 100</div>
                    </div>
                </div>

                <div className="statusContainer">
                    {pretest ? (
                        'Aproveitamento'
                    ) : (
                        <>
                            Nota necessária <span className="statusOutcome">{statusFeed ? 'atingida' : 'não atingida'}</span>
                        </>
                    )}
                </div>
            </div>
            {!pretest && valueAttempt > 0 && (
                <div className="blockCF blockCF02">
                    <div className={'infoAttempt'}>
                        <Button
                            text={'Tentar novamente'}
                            className="button03"
                            callEvent={() => {
                                // COMO AINDA EXISTEM TENTATIVAS VOU INICIAR A AVALIAÇÃO NOVAMENTE.
                                restartEvaluation();
                            }}
                        />
                        <p className="infoAttemptTxt">
                            Você ainda tem{' '}
                            <span className="attemptHighlight">
                                {valueAttempt} {valueAttempt === 1 ? 'tentativa' : 'tentativas'}
                            </span>{' '}
                            {valueAttempt === 1 ? 'disponível' : 'disponíveis'} para realizar esta avaliação novamente.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EvaluationKnowledgeCardFeedback;
